import {
    SkeletonConversationScreen,
    SkeletonTeaserScreen,
    SkeletonComment,
    SkeletonCommentInCardStack
} from 'component/skeleton';
import { DatastoreContext } from 'util/datastoreContext';
import { component, demoFile, DemoBox, story } from 'system/demo';
import { Pad } from 'component/basics';

demoFile('component/skeleton');

function SkeletonTeaserScreenDemo() {
    return (
        <DemoBox>
            <div style={{ width: 400 }}>
                <SkeletonTeaserScreen />
            </div>
        </DemoBox>
    );
}
component("SkeletonTeaserScreen", SkeletonTeaserScreenDemo, {}, [story('Default', [])]);

function SkeletonCommentInCardStackDemo() {
    return (
        <DemoBox>
            <div style={{ width: 400 }}>
                <SkeletonCommentInCardStack />
            </div>
        </DemoBox>
    );
}
component("SkeletonCommentInCardStack", SkeletonCommentInCardStackDemo, {}, [story('Default', [])]);

function SkeletonCommentDemo() {
    return (
        <DemoBox>
            <div style={{ width: 400 }}>
                <p>Plain</p>
                <SkeletonComment />
                <Pad />
                <p>With Shimmer</p>
                <SkeletonComment isShimmerAnimated />
            </div>
        </DemoBox>
    );
}
component("SkeletonComment", SkeletonCommentDemo, {}, [
    story('Plain', []),
    story('With Shimmer', [])
]);

function SkeletonConversationScreenDemo() {
    const mockDatastore = {
        getIsEmbedded: () => false,
        getIsInSidebar: () => false,
        getSiloKey: () => null,
        getLanguage: () => 'english',
    };

    return (
        <DemoBox>
            <DatastoreContext.Provider value={mockDatastore as any}>
                {/* simulate a screen */}
                <div style={{ height: 800, width: 400, borderWidth: 1, borderColor: '#ccc', overflow: 'hidden' }}>
                    <SkeletonConversationScreen />
                </div>
            </DatastoreContext.Provider>
        </DemoBox>
    );
}
component('SkeletonConversationScreen', SkeletonConversationScreenDemo, {}, [story('Default', [])]);
